import React, { Suspense, lazy, useLayoutEffect, useEffect, useContext, useRef } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ConfigProvider, Spin } from "antd";
import { Custom } from "../Config/ThemeConfig";
import { AuthRouter, Redirect } from "./AuthRouter";
import Dashboard from "../Layouts/Dashboard";
import { authRoutes, webRoutes, wenAuthRoute, authRoutesStaff } from "./Route";
import { WebAuthRouter } from "./WebAuthRouter";
import AdminLoginProvider from "../Provider/AdminLoginProvider";
import { useLocation } from "react-router-dom";
import { CRMTracker } from "../Api/CRMTracker";
const AdminLogin = lazy(() => import("../Component/Admin/Login/Login"));
const AdminLoginV2 = lazy(() => import("../Component/Admin/Login/LoginV2"));
const WebLayout = lazy(() => import("../Layouts/WebLayout"));
const NoPage = lazy(() => import("../Layouts/NoPage"));
const get_role = () => {
  const role = localStorage.getItem("nattu_admin_role");
  return role;
};
const Index = () => {
  const { adminRoleFetch } = useContext(AdminLoginProvider);
  useEffect(() => {
    adminRoleFetch();
  }, []);
  const Wrapper = ({ children }) => {
    const location = useLocation();
    useLayoutEffect(() => {
      document.documentElement.scrollTo(500, 0);
    }, [location.pathname]);
    // Fire fbq PageView on every route change (SPA fix)
    const lastFiredPath = useRef("");
    useEffect(() => {
      if (location.pathname !== lastFiredPath.current) {
        CRMTracker("page_view", { page: location.pathname, referrer: document.referrer });
      }
      if (window.fbq && location.pathname !== lastFiredPath.current) {
        lastFiredPath.current = location.pathname;
        window.fbq("track", "PageView");
      } else if (location.pathname !== lastFiredPath.current) {
        lastFiredPath.current = location.pathname;
      }
    }, [location.pathname]);
    return children;
  };
  // basename="/nattu"
  return (
    <ConfigProvider theme={{ token: Custom }}>
      <Router>
        <Wrapper>
          {/* <Suspense
            fallback={
              <div className="splish_screen">
                <Spin />
              </div>
            }
          > */}
          <Routes>
            <Route
              path="/login"
              element={
                <Redirect>
                  <div>Login</div>
                </Redirect>
              }
            />
            <Route
              path="/admin/login"
              element={
                <Redirect>
                  <Suspense
                    fallback={
                      <div className="splish_screen">
                        <Spin />
                      </div>
                    }
                  >
                    <AdminLoginV2 />
                  </Suspense>
                </Redirect>
              }
            />
            <Route
              path="/admin/babyboy"
              element={
                <Redirect>
                  <Suspense
                    fallback={
                      <div className="splish_screen">
                        <Spin />
                      </div>
                    }
                  >
                    <AdminLogin />
                  </Suspense>
                </Redirect>
              }
            />

            <Route path="/" element={<WebLayout />}>
              {webRoutes?.map((e, i) => (
                <Route
                  key={i}
                  path={e?.path}
                  element={
                    <Suspense
                      fallback={
                        <div className="splish_screen">
                          <Spin />
                        </div>
                      }
                    >
                      {e?.element}
                    </Suspense>
                  }
                />
              ))}
              {wenAuthRoute?.map((e, i) => (
                <Route
                  key={i}
                  path={e?.path}
                  element={
                    <WebAuthRouter>
                      <Suspense
                        fallback={
                          <div className="splish_screen">
                            <Spin />
                          </div>
                        }
                      >
                        {e?.element}
                      </Suspense>
                    </WebAuthRouter>
                  }
                />
              ))}
              <Route
                path="404"
                element={
                  <Suspense
                    fallback={
                      <div className="splish_screen">
                        <Spin />
                      </div>
                    }
                  >
                    <NoPage />
                  </Suspense>
                }
              />
              <Route
                path="*"
                element={
                  <Suspense
                    fallback={
                      <div className="splish_screen">
                        <Spin />
                      </div>
                    }
                  >
                    <NoPage />
                  </Suspense>
                }
              />
            </Route>
            <Route
              path="/"
              element={
                <AuthRouter>
                  <Suspense
                    fallback={
                      <div className="splish_screen">
                        <Spin />
                      </div>
                    }
                  >
                    <Dashboard />
                  </Suspense>
                </AuthRouter>
              }
            >
              {authRoutes !== null && get_role() === "superadmin"
                ? authRoutes.map((item, index) => (
                    <Route
                      key={index}
                      path={"admin" + item.path}
                      element={
                        <Suspense
                          fallback={
                            <div className="splish_screen">
                              <Spin />
                            </div>
                          }
                        >
                          {item.element}
                        </Suspense>
                      }
                    />
                  ))
                : authRoutesStaff?.map((item, index) => (
                    <Route
                      key={index}
                      path={"admin" + item.path}
                      element={
                        <Suspense
                          fallback={
                            <div className="splish_screen">
                              <Spin />
                            </div>
                          }
                        >
                          {item.element}
                        </Suspense>
                      }
                    />
                  ))}
              <Route
                path="404"
                element={
                  <Suspense
                    fallback={
                      <div className="splish_screen">
                        <Spin />
                      </div>
                    }
                  >
                    <NoPage />
                  </Suspense>
                }
              />
              <Route
                path="*"
                element={
                  <Suspense
                    fallback={
                      <div className="splish_screen">
                        <Spin />
                      </div>
                    }
                  >
                    <NoPage />
                  </Suspense>
                }
              />
            </Route>
            <Route
              path="404"
              element={
                <Suspense
                  fallback={
                    <div className="splish_screen">
                      <Spin />
                    </div>
                  }
                >
                  <NoPage />
                </Suspense>
              }
            />
            <Route
              path="*"
              element={
                <Suspense
                  fallback={
                    <div className="splish_screen">
                      <Spin />
                    </div>
                  }
                >
                  <NoPage />
                </Suspense>
              }
            />
          </Routes>
          {/* </Suspense> */}
        </Wrapper>
      </Router>
    </ConfigProvider>
  );
};

export default Index;
